import { render, staticRenderFns } from "./EmploymentLeaveAllowancesTableRow.vue?vue&type=template&id=77949d9e"
import script from "./EmploymentLeaveAllowancesTableRow.vue?vue&type=script&lang=js"
export * from "./EmploymentLeaveAllowancesTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports